import type {
  DataTableLegendItem,
  RowBgColorResult,
} from "@/components/ui/DataTable/index";
import type { DocumentDispatchListItemDto } from "@/lib/api/otcDocuments";

const problemSigningStatuses: readonly string[] = [
  "cancelled",
  "revoked",
  "declined",
  "expired",
  "deleted",
  "trashed",
];

export const documentDispatchStatusLegend: DataTableLegendItem[] = [
  { color: { preset: "light-red" }, label: "Failed or requires attention" },
  { color: { preset: "light-green" }, label: "Sent" },
  { color: { preset: "light-blue" }, label: "Queued to send" },
  { color: { preset: "light-yellow" }, label: "Requires review" },
];

export function documentDispatchRowBgColor(
  row: DocumentDispatchListItemDto,
): RowBgColorResult | undefined {
  if (
    row.preparationStatus === "failed"
    || row.deliveryStatus === "failed"
  ) {
    return { preset: "light-red" };
  }

  if (
    row.deliveryStatus === "submitted"
    || row.signing?.lastStatus === "sent"
    || row.signing?.lastStatus === "completed"
  ) {
    return { preset: "light-green" };
  }

  if (row.deliveryStatus === "queued") {
    return { preset: "light-blue" };
  }

  if (
    row.preparationStatus === "ready"
    && row.requiresReview
    && row.approvedAt === null
  ) {
    return { preset: "light-yellow" };
  }

  return undefined;
}
